// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"Overall_bottomLine__lvMQG","main":"Overall_main__3ques"};